<template>
  <SearchForm ref="searchFormRef" :formModel="searchController.formModel" @search="tableController.search" :searchLoading="tableController.loading">
    <template #form>
      <el-form-item prop="departName">
        <el-input placeholder="科室中心名称" v-model="searchController.formModel.departName" clearable></el-input>
      </el-form-item>
      <el-form-item prop="doctorCode">
        <FetchSelect placeholder="医生" v-model="searchController.formModel.doctorCode" api="/web/system/doctorncp/getDoctorList" valueKey="doctorCode" textKey="doctorName" />
      </el-form-item>
      <el-form-item prop="disabled">
        <el-select placeholder="状态" v-model="searchController.formModel.disabled" clearable>
          <el-option label="有效" :value="0"></el-option>
          <el-option label="无效" :value="1"></el-option>
        </el-select>
      </el-form-item>
    </template>
    <template #controll>
      <el-button type="primary" @click="clickAdd">新建</el-button>
    </template>
  </SearchForm>
  <ProTable
    :tableId="tableController.tableId"
    :columns="tableController.columns"
    :tableData="tableController.tableData"
    :loading="tableController.loading"
    :total="tableController.total"
    :pageState="tableController.pageState"
    @pageChange="tableController.onPageChange"
  />

  <!-- 模态 -->
  <AddModal ref="addModalRef" @successAdd="tableController.search" @successEdit="tableController.refresh" />
  <AssociatedDoctorModal ref="associatedDoctorModalRef" />
</template>

<script>
import { ref } from 'vue'
import { ElMessage } from 'element-plus'
import SearchForm from '@/components/SearchForm'
import ProTable from '@/components/ProTable'
import AddModal from './AddModal.vue'
import FetchSelect from '@/components/FetchSelect'
import CustomLink from '@/components/customStyle/CustomLink'
import useSearchFormCtrller from '@/hooks/useSearchFormCtrller'
import useTableController from '@/hooks/useTableController'
import { actionConfirm } from '@/utils/confirm'
import request from '@/utils/request'
import AssociatedDoctorModal from './AssociatedDoctorModal.vue'

export default {
  setup() {
    const addModalRef = ref(null)
    const associatedDoctorModalRef = ref(null)
    // searchForm
    const searchController = useSearchFormCtrller({
      form: {
        departName: '',
        doctorCode: '',
        disabled: '',
      },
    })
    // table
    const columns = [
      { label: '科室中心名称', prop: 'departName', width: 170 },
      { label: '科室中心简介', prop: 'departDesc' },
      { label: '排序', prop: 'departSeq', width: 80 },
      { label: '创建时间', prop: 'createDateStr' },
      { label: '状态', prop: 'disabledName', width: 80 },
      {
        label: '操作',
        prop: 'actions',
        width: 100,
        render: (_, record) => {
          const statusText = record.disabled == '0' ? '失效' : '生效'
          return (
            <div>
              <CustomLink
                onClick={() => {
                  clickEdit(record)
                }}
              >
                编辑
              </CustomLink>
              <CustomLink
                onClick={() => {
                  handleToggleStatus(record)
                }}
              >
                {statusText}
              </CustomLink>
              <CustomLink
                onClick={() => {
                  associatedDoctorModalRef.value?.open(record)
                }}
              >
                关联
              </CustomLink>
            </div>
          )
        },
      },
    ]
    const tableController = useTableController({
      tableId: 'depart_center_mng_table',
      columns,
      ajax: ({ page, pageSize }) => {
        const postData = {
          page,
          rows: pageSize,
          ...searchController.formModel,
        }
        return request({
          url: '/web/system/departcenter/getDepartCenterList',
          data: postData,
        }).then((data) => ({ list: data.data ?? [], totalNum: data.rowTop ?? 0 }))
      },
    })

    function clickAdd() {
      addModalRef.value?.open()
    }

    function clickEdit(record) {
      addModalRef.value?.open(record)
    }

    function handleToggleStatus(record) {
      const statusText = record.disabled == '0' ? '失效' : '生效'
      actionConfirm(`确认${statusText}？`, () => {
        return request({
          url: '/web/system/departcenter/updateDepartCenterDisabled',
          data: {
            departCenterCode: record.departCenterCode,
            disabled: record.disabled == '0' ? '1' : '0',
          },
        }).then(() => {
          tableController.refresh()
          ElMessage.success('操作成功')
        })
      })
    }

    return {
      searchController,
      tableController,
      //
      addModalRef,
      associatedDoctorModalRef,
      clickAdd,
    }
  },
  components: { SearchForm, ProTable, FetchSelect, AddModal, AssociatedDoctorModal },
}
</script>

<style></style>
